module.exports = __webpack_public_path__ + "static/media/vmcare_logo.9b4fc9b5.svg";